var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_900",
    "data-name": "Group 900",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.29,
    height: 27.504,
    viewBox: "0 0 27.29 27.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 27.29,
    height: 27.504,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M1.1,27.5A1.082,1.082,0,0,1,.046,26.2l1.348-6.543A13.652,13.652,0,0,1,12.978.016a13.526,13.526,0,0,1,10.236,3.9,13.646,13.646,0,0,1-9.781,23.372,13.5,13.5,0,0,1-5.675-1.331l-6.4,1.517A1.077,1.077,0,0,1,1.1,27.5M13.654,1.146c-.206,0-.413.005-.621.015A12.5,12.5,0,0,0,2.506,19.322L2.6,19.5,1.189,26.336l6.706-1.588.185.092a12.363,12.363,0,0,0,5.371,1.3l.191,0a12.551,12.551,0,0,0,12.5-12.1,12.5,12.5,0,0,0-12.484-12.9",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M21.886,25.626c-1.717,0-4.06-.732-6.906-3.388-2.645-2.469-3.869-4.882-3.637-7.172a4.8,4.8,0,0,1,1.847-2.892,1.517,1.517,0,0,1,2.368.543l1.066,2.409a1.514,1.514,0,0,1-.187,1.541l-.541.7a.345.345,0,0,0-.03.386,13.2,13.2,0,0,0,4.079,3.6.352.352,0,0,0,.379-.083l.618-.631a1.514,1.514,0,0,1,1.5-.395l2.531.727a1.516,1.516,0,0,1,.861,2.272,4.8,4.8,0,0,1-2.614,2.224,5.68,5.68,0,0,1-1.339.158M14.171,12.96a.373.373,0,0,0-.241.089,3.649,3.649,0,0,0-1.446,2.132c-.194,1.915.909,4.007,3.279,6.219,3.477,3.246,6,3.244,7.192,2.955a3.654,3.654,0,0,0,1.916-1.724.37.37,0,0,0,.034-.332.364.364,0,0,0-.244-.225h0l-2.532-.727a.375.375,0,0,0-.367.1l-.619.631a1.5,1.5,0,0,1-1.627.342,14.072,14.072,0,0,1-4.643-4.092,1.486,1.486,0,0,1,.117-1.658l.541-.7a.37.37,0,0,0,.045-.376l-1.066-2.41a.362.362,0,0,0-.255-.211.384.384,0,0,0-.084-.01",
    transform: "translate(-4.83 -5.042)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.43f6f52ae17e8d51fb8896cb21201877.svg";
export { ForwardRef as ReactComponent };